import { useState, useEffect, createContext, useContext } from "react";
import { useArrangement } from "./ArrangementProvider";
import PropTypes from 'prop-types';
const NavContext = createContext();
export const useNav = () => useContext(NavContext);

const NavProvider = ({ children }) => {
  const { hasArrangement } = useArrangement();
  const [hideHeaderNavBars, setHideHeaderNavBars] = useState(false);
  const [navigation, setNavigation] = useState(null);
  const [showFooter, setShowFooter] = useState(false);
  const [showCallMeIcon, setShowCallMeIcon] = useState(true);
  const [hideSignOut, setHideSignOut] = useState(false);

  useEffect(() => {
    setNavigation([
      {
        name: "My Financial Statement",
        id: "nav-sfs",
        href: "/sfs",
        current: false,
        hide: false,
      },
      {
        name: "Transactions",
        id: "transaction-history",
        href: "/transactionhistory",
        current: false,
        hide: false,
      },
      {
        name: "Manage Saved Cards",
        id: "manage-cards",
        href: "/managecards",
        current: false,
        hide: false,
      },
    ]);
  }, [hasArrangement]);

  useEffect(() => {
    const navItems = [
      {
        name: "My Financial Statement",
        id: "nav-sfs",
        href: "/sfs",
        current: false,
        hide: hideHeaderNavBars,
      },
      {
        name: "Transactions",
        id: "transaction-history",
        href: "/transaction-history",
        current: false,
        hide: hideHeaderNavBars,
      },
      {
        name: "Manage Saved Cards",
        id: "manage-cards",
        href: "/manage-cards",
        current: false,
        hide: hideHeaderNavBars,
      },
    ];
    setNavigation(navItems);
  }, [hideHeaderNavBars]);

  const contextValue = {
    navigation,
    settings: [{ name: "Sign out", id: "logout", href: "#" }],
    showFooter,
    setShowFooter,
    hideHeaderNavBars,
    setHideHeaderNavBars,
    showCallMeIcon,
    setShowCallMeIcon,
    setHideSignOut,
    hideSignOut,
  };

  return (
    <NavContext.Provider value={contextValue}>{children}</NavContext.Provider>
  );
};

NavProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default NavProvider;
